export enum ButtonVariant {
  Primary = 'Primary',
  Subtle = 'Subtle',
  Outline = 'Outline',
  Ghost = 'Ghost',
  Warning = 'Warning',
}
